const options = {
  5: "bg-violet-600/5",
  10: "bg-violet-600/10",
  25: "bg-violet-600/25",
  50: "bg-violet-600/50",
  75: "bg-violet-600/75",
  90: "bg-violet-600/90",
  100: "bg-violet-600",
};

const from = {
  5: "from-violet-600/5",
  10: "from-violet-600/10",
  25: "from-violet-600/25",
  50: "from-violet-600/50",
  75: "from-violet-600/75",
  90: "from-violet-600/90",
  100: "from-violet-600",
};

export default function getBackgroundViolet600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
